export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/brands/state.js